"use strict";
/* eslint-disable no-param-reassign */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
const _ = __importStar(require("lodash"));
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
exports.concentrationLimitPointerMethods = [
    {
        method: 'viablyViola1.avgReceivableOutstanding',
        pointerImplementation: ({ concentrationReceivables, valueConfig }) => {
            const concentrationLimit = valueConfig.limit;
            const groupByFieldType = 'string';
            const groupingField = 'org_id';
            const method = 'viablyViola1.avgReceivableOutstanding';
            concentrationReceivables.forEach((rec) => {
                (0, common_1.finleyAssert)(typeof rec.baseFields[groupingField] === groupByFieldType, `baseFields.${groupingField} must be defined to run ${method}. Found [${rec.baseFields[groupingField]}}]`);
            });
            const grouped = _.groupBy(concentrationReceivables, (rec) => rec.baseFields[groupingField]);
            let totalExposure = 0;
            let totalGroups = 0;
            const totalExposureByGroup = new Map();
            // kick out any groups that have zero exposure.
            _.forEach(_.toPairs(grouped), ([group, receivables]) => {
                const groupExposure = _.sumBy(receivables, (rec) => rec.concentrationLimitFields
                    .eligibleExposureLessConcentrationLimitKickouts);
                if (groupExposure !== 0) {
                    // we only want to consider groups that have some exposure.
                    totalExposureByGroup.set(group, groupExposure);
                    totalExposure += groupExposure;
                    // eslint-disable-next-line no-plusplus
                    totalGroups++;
                }
                else {
                    // remove the group that we do not care about.
                    delete grouped[group];
                }
            });
            // find average of total exposure amoung gropups
            const maxAverage = concentrationLimit;
            const maxExposure = maxAverage * totalGroups;
            const receivables = _.flatten(_.values(grouped));
            // now we want to make sure that exposure is not greater than max exposure.
            return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                concentrationLimit: maxExposure,
                totalConcentrationExposure: totalExposure,
                concentrationReceivables: receivables,
                concentrationLimitValueType: 'number',
            });
            // we can also use weighted average.
            // but that kicks out whole receivable, thus may exceed
            // kickouts. (@callie wants standard)
            // return calculateWeightedAverageConcentrationLimitKickouts({
            //   concentrationLimit: maxExposure,
            //   field:
            //     'concentrationLimitFields.eligibleExposureLessConcentrationLimitKickouts',
            //   concentrationReceivables: receivables,
            //   limitType: 'max',
            //   weighting: 'constant',
            // });
        },
    },
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map